//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { authService } from '@/services';
import { type AppConfig } from '@/services/apiTypes';

// The filtered application config (`config/app`): what every user-facing
// surface derives its available models, auth types and feature flags from.
// A pre-auth read -- the login page needs `auth_types` before there is a
// session -- so the query carries no `enabled` gate.

export const appConfigKeys = {
  all: ['appConfig'] as const
};

// Never expires on its own: it changes with a server-side config change or
// an admin's write, and a write that changes it invalidates this key, so a
// focus refetch would only re-read what is already current.
export const appConfigQuery = () => ({
  queryKey: appConfigKeys.all,
  queryFn: (): Promise<AppConfig> => authService.getAppConfig(),
  staleTime: Infinity,
  refetchOnWindowFocus: false
});
